export enum LoginErrorsEnum {
  userNotFound = 'user_not_found',
  userLoginFailed = 'user_login_failed',
  badUserState = 'bad_user_state',
  badDatetime = 'bad_datetime',
  userDisabled = 'user_disabled',
}
